<div mat-dialog-title style="display: flex">
  <span>Edit Meals Units</span>
  <span style="flex: auto"></span>
</div>

<div mat-dialog-content>

  <dx-validation-group #targetGroup>

    <ng-container *ngFor="let item of items">

      <fieldset *ngIf="config.get(item.config, false)">
        <legend>{{ item.name }} Meals</legend>

        <table>
          <tr>
            <th></th>
            <ng-container *ngFor="let month of months">
              <th style="font-size: .6em;">{{ formatMonth(month) }}</th>
            </ng-container>
          </tr>
          <tbody>
          <tr>
            <td style="font-size: .7em;">
              Quantity
            </td>

            <ng-container *ngFor="let month of months">

              <td style="position: relative;">
                <dx-number-box
                  [min]="0"
                  [max]="allowedMonthsMap[item.code][month]"
                  [showSpinButtons]="true"
                  [(value)]="value[item.code][month]"
                  [readOnly]="allowedMonthsMap[item.code][month] <= 0"
                >
                  <dx-validator [name]="item.name + ' Meals Quantity for ' + month">
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                    <dxi-validation-rule type="numeric" [min]="0"></dxi-validation-rule>
                    <dxi-validation-rule type="numeric"
                                         [max]="allowedMonthsMap[item.code][month]"></dxi-validation-rule>
                  </dx-validator>
                </dx-number-box>

                <span style="font-size: 8px; color: gray; position: absolute; bottom: -10px; left: 5px;">
                  {{ usedMonthsMap[item.code][month] }} used of {{ authorizedMonthsMap[item.code][month] }} authorized
                </span>
              </td>

            </ng-container>
          </tr>
          </tbody>
        </table>

      </fieldset>

    </ng-container>

    <dx-validation-summary></dx-validation-summary>
  </dx-validation-group>


  <!--              <dx-tag-box-->
  <!--                [dataSource]="value[item.code].dates"-->
  <!--                [value]="value[item.code].dates"-->
  <!--                [showSelectionControls]="true"-->
  <!--                applyValueMode="instantly"-->

  <!--                [displayExpr]="dateExpr"-->

  <!--                [showClearButton]="true"-->
  <!--                [buttons]="tagBoxButtonsMap[item.code]"-->
  <!--                (onValueChanged)="datesValueChanged($event, item.code)"-->
  <!--              >-->

  <!--&lt;!&ndash;                <dx-validator [name]="item.name + ' Meals Dates'">&ndash;&gt;-->
  <!--&lt;!&ndash;                  <dxi-validation-rule&ndash;&gt;-->
  <!--&lt;!&ndash;                    type="custom"&ndash;&gt;-->
  <!--&lt;!&ndash;                    [validationCallback]="validateDates(item.code)"&ndash;&gt;-->
  <!--&lt;!&ndash;                  ></dxi-validation-rule>&ndash;&gt;-->
  <!--&lt;!&ndash;                </dx-validator>&ndash;&gt;-->
  <!--              </dx-tag-box>-->

  <!--  <dx-popup-->
  <!--    *ngIf="popupVisible"-->
  <!--    [visible]="popupVisible"-->
  <!--    (onHiding)="popupVisible = false"-->
  <!--    [showTitle]="true"-->
  <!--    title="Select dates"-->
  <!--    [width]="300"-->
  <!--    [height]="300"-->
  <!--    [dragEnabled]="true"-->
  <!--    [closeOnOutsideClick]="true"-->
  <!--  >-->
  <!--    <ng-container *dxTemplate="let data of 'content'">-->
  <!--      <dx-calendar-->
  <!--        type="date"-->
  <!--        dateSerializationFormat="yyyy-MM-dd"-->
  <!--        zoomLevel="month"-->
  <!--        maxZoomLevel="month"-->
  <!--        [min]="minDate"-->
  <!--        [max]="maxDate"-->
  <!--        [disabledDates]="disableDates"-->
  <!--        (onValueChanged)="confirmAdd($event)"-->
  <!--      >-->
  <!--        <ng-container *dxTemplate="let data of 'cell'">-->
  <!--          <span [ngClass]="{ 'date-selected': dateSelected(data) }" style="position: relative;">-->
  <!--            {{ data.text }}-->
  <!--            <div style="position: absolute; bottom: -4px; right: -5px; font-size: 9px; color: darkorange">-->
  <!--              {{ dateUnits(data) }}-->
  <!--            </div>-->
  <!--          </span>-->
  <!--        </ng-container>-->
  <!--      </dx-calendar>-->
  <!--    </ng-container>-->
  <!--  </dx-popup>-->

<!--  <pre>{{ value | json }}</pre>-->
</div>

<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">Cancel</button>
  <button mat-button (click)="validateGroup()">Set</button>
</div>
